// unit: filter
import {isArray,isString} from "../../../funcs";

/**
     * FilterQuery - условия для поиска
     * @param {Array} queries условие для поиска в виде массива
     * @constructs FilterQuery
     * @example <caption>Создание условия</caption>
     * var query = new FilterQuery(
     * 	[
     * 	  "AND",
     * 	  "x",
     * 	  "y",
     * 	  [
     * 	    "OR",
     * 	    "a",
     * 	    "b",
     * 	    "c"
     * 	  ]
     *  ]
     * );
     */
class FilterQuery {
    constructor(queries) {
        // ["AND", "x", ["OR", "b", "c"]]
        let operator = "AND";
        let _queries = [];

        if ( isArray(queries) ) {
            [operator, ..._queries] = queries;
        }

        this.operator = operator;
        this.queries = _queries;


        let i;
        let query;

        for (i = 0; i < this.queries.length; i++) {
            query = this.queries[i];

            if ( isArray(query) ) {
                this.queries[i] = new FilterQuery(query);
            }
        }
    }

    add(query) {
        this.queries.push(query);
        return this;
    }

    setOperator(operator) {
        this.operator = operator;
    }

    toArray() {
        let elem;
        let arr = [this.operator];

        for (let i = 0; i < this.queries.length; i++) {
            elem = this.queries[i];

            if ( isString(elem) ) {
                arr.push(elem);
                continue;
            }

            if ( isArray(elem) ) {
                elem = new FilterQuery(elem);
            }
            if ( elem instanceof FilterQuery ) {
                arr.push(elem.toArray());
            }
        }

        return arr;
    }

    compile() {
        return this.toArray();
    }

    /**
         * Проверка условия, используя подсчитанные condResults
         * @param  {Object} condResults
         * @return {Boolean}             true, если набор condResults подходит под условие
         */
    check(condResults) {
        let i;
        let query;

        if ( this.operator == "AND" ) {
            for (i = 0; i < this.queries.length; i++) {
                query = this.queries[i];

                if ( query instanceof FilterQuery ) {
                    if ( !query.check(condResults) ) {
                        return false;
                    }
                } else if ( !condResults[query] ) {
                    return false;
                }
            }

            return true;
        }

        if ( this.operator == "OR" ) {
            for (i = 0; i < this.queries.length; i++) {
                query = this.queries[i];

                if ( query instanceof FilterQuery ) {
                    if ( query.check(condResults) ) {
                        return true;
                    }
                } else if ( condResults[query] ) {
                    return true;
                }
            }

            return false;
        }

        return true;
    }

    /**
         * Проверяем есть ли в запросе нужный ключ условия
         * @param {String} key ключ условия. Example ["AND", key]
         * @return {Boolean}     true, если в запросе уже есть условие
         */
    has(key) {
        let query;

        for (let i = 0; i < this.queries.length; i++) {
            query = this.queries[i];

            if ( query instanceof FilterQuery ) {
                if ( query.has(key) ) {
                    return true;
                }
            } else if ( query == key ) {
                return true;
            }
        }

        return false;
    }

    /**
         * Пустой ли фильтр?
         * @return {Boolean} true, если query.check(anyModel) === true
         */
    isEmpty() {
        return !this.queries.length;
    }

    /**
         * Удаляем ключ из условия
         * @param  {String} key ключ условия, которое нужно удалить
         */
    remove(key) {
        let query;

        for (let i = 0, n = this.queries.length; i < n; i++) {
            query = this.queries[i];

            if ( query instanceof FilterQuery ) {
                if ( query.has(key) ) {
                    query.remove(key);

                    if ( query.isEmpty() ) {
                        this.queries.splice(i, 1);
                        n--;
                        i--;
                    }
                }
            } else if ( query == key ) {
                this.queries.splice(i, 1);
                n--;
                i--;
            }

        }
    }

    // for debug
    toString() {
        let elem;
        let arr = [];
        for (let i = 0; i < this.queries.length; i++) {
            elem = this.queries[i];

            if ( isString(elem) ) {
                arr.push(elem);
                continue;
            }

            if ( isArray(elem) ) {
                elem = new FilterQuery(elem);
            }

            if ( elem instanceof FilterQuery ) {
                arr.push("(" + elem.toString() + ")");
            }
        }

        return arr.join(" " + this.operator + " ");
    }
}

export default FilterQuery;
